/**
 * VerdictChip — Cockpit Component
 * Renders a verdict phrase chip with a colored dot, replacing the uniform
 * "Needs your review" chip on cockpit deal rows.
 *
 * Authority: WI-UI-CLEANUP-001 Stage 2, ui-invariants.js VERDICT_PILL tokens.
 * Mirror idiom: frontend/src/components/shared/RecommendationPill.jsx
 */

import React from 'react';
import { VERDICT_PILL } from '@/config/ui-invariants';

/**
 * @param {{ phrase: string, tone: 'strong'|'moderate'|'weak'|'unclear' }} props
 */
export function VerdictChip({ phrase, tone }) {
  const v = VERDICT_PILL[tone] || VERDICT_PILL.unclear;

  return (
    <span
      data-testid="verdict-chip"
      data-tone={tone}
      style={{
        ...VERDICT_PILL.pill,
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        background: v.background,
        color: v.text,
        border: `1px solid ${v.border}`,
        whiteSpace: 'nowrap',
        flexShrink: 0,
      }}
    >
      <span
        style={{
          width: '6px',
          height: '6px',
          borderRadius: '50%',
          background: v.dot,
          flexShrink: 0,
        }}
      />
      {phrase}
    </span>
  );
}

export default VerdictChip;
